import axios from '../../../../config/axiosV2';
import { Location, LocationData, WBLabel } from './types';

const isLocationData = (data: unknown): data is LocationData => {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  const typedData = data as { location?: { id?: string } };
  return Boolean(typedData.location && typeof typedData.location.id === 'string');
};

const getAllLocations = async (): Promise<Location[]> => {
  const url = '/whiteboard/map/locations';
  try {
    const { data } = await axios.get(url);
    const { locations }: { locations: Location[] } = data;
    return locations;
  } catch {
    return [];
  }
};

const getSingleLocation = async (): Promise<LocationData | null> => {
  const url = '/whiteboard/map/location';
  try {
    const { data } = await axios.get(url);
    if (!isLocationData(data)) {
      throw Error('Invalid location payload');
    }
    return data;
  } catch {
    throw Error('Failed to fetch whiteboard location');
  }
};

// function for creating a new label connected to the Location of User
const createNewLabelForLocation = async ({
  locationId,
  name,
}: {
  locationId: string;
  name: string;
}): Promise<WBLabel> => {
  const url = `whiteboard/map/add-new-label/${locationId}`;
  try {
    const { data } = await axios.post(url, { name });
    const newLabel: WBLabel = data.newLabel;
    return newLabel;
  } catch {
    throw Error('Failed to create new label');
  }
};

const deleteLabelForLocation = async (locationId: string, labelId: string): Promise<string | boolean> => {
  const url = `whiteboard/map/label/${locationId}/${labelId}`;
  try {
    const { data } = await axios.delete(url);
    return data.wbLabelId;
  } catch {
    throw Error('Failed to delete label');
  }
};

const updateLabelForLocation = async (locationId: string, labelId: string, name: string): Promise<string | boolean> => {
  const url = `whiteboard/map/label/${locationId}/${labelId}`;
  try {
    const { data } = await axios.put(url, { name });
    return data.label.id;
  } catch {
    throw Error('Failed to delete label');
  }
};
export {
  createNewLabelForLocation,
  deleteLabelForLocation,
  getAllLocations,
  getSingleLocation,
  updateLabelForLocation,
};
